import React, { Component } from 'react';
import CommonModal from './CommonModal';
import Button from './Button';
import PropTypes from 'prop-types';

class Modal extends Component {
  static propTypes = {
    header: PropTypes.node,
    body: PropTypes.node,
    cancel: PropTypes.node,
    submit: PropTypes.node,
    hideModal: PropTypes.func,
    closeOnClick: PropTypes.bool,
    isOpen: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = { isOpen: false, args: [] };
  }

  showModal = (...args) => {
    this.setState({ args, isOpen: true });
  };

  hideModal = () => {
    const { hideModal } = this.props;
    if (typeof hideModal === 'function') {
      hideModal();
    } else {
      this.setState({ isOpen: false });
    }
  };

  handleSubmit = () => {
    if (this.props.onSubmit) {
      if (this.props.onSubmit.call(this, ...this.state.args)) {
        this.hideModal();
      }
    } else {
      this.hideModal();
    }
  };

  componentWillUpdate(nextProps, nextState) {
    const isOpen = typeof this.props.isOpen === 'undefined' ? this.state.isOpen : this.props.isOpen;
    const isOpenNext = typeof nextProps.isOpen === 'undefined' ? nextState.isOpen : nextProps.isOpen;
    if (isOpen && !isOpenNext) {
      document.body.style.overflow = '';
    } else if (!isOpen && isOpenNext) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
  }

  render() {
    const { header, body, cancel, submit, closeOnClick, isOpen, widthFixed } = this.props;
    return (
      <CommonModal {...{ isOpen, closeOnClick }} hideModal={this.hideModal} widthFixed={widthFixed}>
        <CommonModal.Header hideModal={this.hideModal}>{header}</CommonModal.Header>
        <CommonModal.Body>{body}</CommonModal.Body>
        <CommonModal.Footer>
          <CommonModal.Buttons>
            <Button onClick={this.hideModal}>{cancel}</Button>
            <Button primary onClick={this.handleSubmit}>
              {submit}
            </Button>
          </CommonModal.Buttons>
        </CommonModal.Footer>
      </CommonModal>
    );
  }
}

export default Modal;
